module.exports = __webpack_public_path__ + "img/PCaravan64_ua.ac166339.webp";